module.exports = __webpack_public_path__ + "img/sintomas ponto colheita 2.4090c315.webp";